/* globals Store */
import api from './backend-api'

export default {
  login (key, cb) {
    cb = arguments[arguments.length - 1]
    let data = 'userkey=' + key
    api.login('login.php', data).then((res) => {
      const token = res.access_token || res.data.access_token
      const user = res.user || res.data.user
      Store.dispatch('user/updateUser', {user, token})
      if (cb) cb(true, null)
      this.onChange(true)
    }, (err) => {
      console.log(err)
      if (cb) cb(false, err)
      this.onChange(false)
    })
  },
  getToken () {
    return Store.state.user.token
  },
  logout (cb) {
    localStorage.userkey = null;
    api.logout().then((res) => {
        Store.dispatch('user/logout')
    }, (err) => {
      if (cb) cb(false, err)
      this.onChange(false)
    })


  },
  loggedIn () {
    return !!Store.state.user.token
  },
  onChange () {}
}



// WEBPACK FOOTER //
// ./src/utils/auth.js